import React from 'react';
import Card from '../UI/Card';
import { GameRoomItem, GameRoomStatus } from '../../api/services/dashboard.service';

interface GameRoomsProps {
  rooms: GameRoomItem[];
}

const statusStyles: Record<
  GameRoomStatus,
  { dot: string; text: string; bg: string; label: string }
> = {
  live: {
    dot: 'bg-green-500',
    text: 'text-green-700',
    bg: 'bg-green-50',
    label: 'Live',
  },
  waiting: {
    dot: 'bg-yellow-500',
    text: 'text-yellow-700',
    bg: 'bg-yellow-50',
    label: 'Waiting',
  },
  closed: {
    dot: 'bg-gray-400',
    text: 'text-gray-600',
    bg: 'bg-gray-100',
    label: 'Closed',
  },
};

const GameRooms: React.FC<GameRoomsProps> = ({ rooms }) => {
  return (
    <Card>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base font-semibold text-gray-900">Game Rooms</h2>
        <span className="text-[10px] text-gray-400">
          {rooms.length} room{rooms.length !== 1 ? 's' : ''}
        </span>
      </div>

      <div className="space-y-3 max-h-[420px] overflow-y-auto pr-1">
        {rooms.length > 0 ? (
          rooms.map((room) => {
            const style = statusStyles[room.status];

            return (
              <div
                key={room.id}
                className="p-3 rounded-lg hover:bg-gray-50 transition-colors border border-gray-100"
              >
                <div className="flex items-center gap-2">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {room.roomId}
                  </p>
                  <span
                    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium ${style.bg} ${style.text}`}
                  >
                    <span className={`w-1.5 h-1.5 rounded-full ${style.dot}`} />
                    {style.label}
                  </span>
                </div>

                <p className="text-xs text-gray-500 mt-1">
                  <span className="font-medium text-gray-700">
                    {room.playersCount}
                  </span>{' '}
                  player{room.playersCount !== 1 ? 's' : ''}
                  {' · '}
                  <span className="font-medium text-gray-700">
                    {room.reservedCount}
                  </span>{' '}
                  reserved
                  {' · '}
                  Stake ETB {room.betAmount.toLocaleString()}
                </p>
              </div>
            );
          })
        ) : (
          <div className="text-center py-4 text-sm text-gray-500">
            No active rooms
          </div>
        )}
      </div>
    </Card>
  );
};

export default GameRooms;